const collapsibleChildStyles = {
    aspectRatio: 'auto',
    height: 'auto',
};

export const getCollapsibleColumnStyles = component => {
    if (component === 'textModule') return collapsibleChildStyles;
};
